import {AuditMixin, AuditMixinAttributes, AuditMixinRelationships} from "./audit-mixin";
import {DEFAULT, LIST_RELATIONSHIP_TYPE} from "./shared-types";
import {StringFormatType} from "../_typing/config/string-format-type";

export type ConstantPropertyDataType = 'float' | 'string' | 'datetime' | 'series' | 'file' | 'user' | 'user_group' | 'account' | 'list';

export type ConstantPropertyAggregation = 'total' | 'mean' | 'count' | 'min' | 'max';

/** Kept beside the type so an option list a form renders cannot drift from the values it may hold. */
export const CONSTANT_PROPERTY_AGGREGATIONS: ConstantPropertyAggregation[] =
    ['total', 'mean', 'count', 'min', 'max'];

export class ConstantPropertyAttributes extends AuditMixinAttributes {
    name: string | null;
    description: string | null;
    alias: string | null;
    name_formula: string | null;
    aggregation: ConstantPropertyAggregation | null;
    is_drop_down_list: boolean;
    is_calculation: boolean;
    data_type: ConstantPropertyDataType = 'string';
    file_type: string;
    json: any | null;
    name_format: StringFormatType | null;
}

export class ConstantPropertyRelationships extends AuditMixinRelationships {
    event_types: LIST_RELATIONSHIP_TYPE = DEFAULT.LIST;
    component_types: LIST_RELATIONSHIP_TYPE;
}

export class ConstantProperty extends AuditMixin {
    attributes: ConstantPropertyAttributes;
    id: string;
    type: string = 'constant_property';
    relationships: ConstantPropertyRelationships;

    constructor() {
        super();
        this.attributes = new ConstantPropertyAttributes();
        this.relationships = new ConstantPropertyRelationships();
    }
}

export function isConstantProperty(property): property is ConstantProperty {
    return property?.type === 'constant_property';
}
